import { Controller } from "react-hook-form";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FormControl from "@mui/material/FormControl";
import { getDateTime, localeDateFormat } from "../../utils/dateTimeHelper";
import "./DatePickerInput.css";

const INITIAL_FORMAT = "yyyy-MM-dd";
const DEFAULT_FORMAT = localeDateFormat;

const DatePickerInput = (props) => {
    const {
        name, label, control, error, placeholder, disabled,
        initFormat = INITIAL_FORMAT,
        format = DEFAULT_FORMAT,
        disableFuture,
        maxDate, minDate,
    } = props;

    const maxDateTime = maxDate ? getDateTime(maxDate, initFormat) : undefined;
    const minDateTime = minDate ? getDateTime(minDate, initFormat) : undefined;

    return (
        <LocalizationProvider dateAdapter={AdapterLuxon}>
            <FormControl error={!!error} className={`date-picker-input${disabled ? " field-disabled" : ""}`}>
                {label && <label htmlFor={name}>{label}</label>}
                <Controller
                    name={name}
                    control={control}
                    render={({ field: { onChange, value } }) => {
                        const valueDateTime = value ? getDateTime(value, initFormat) : null;
                        const onChangeDate = (newValue) => {
                            if (newValue?.isValid) {
                                onChange(newValue.toFormat(initFormat));
                            }
                        };

                        return (
                            <DatePicker
                                value={valueDateTime}
                                disabled={disabled}
                                placeholder={placeholder}
                                format={format}
                                minDate={minDateTime}
                                maxDate={maxDateTime}
                                onChange={onChangeDate}
                                disableFuture={disableFuture}
                                slotProps={{
                                    textField: { error: !!error, helperText: error },
                                }}
                            />
                        );
                    }}
                />
            </FormControl>
        </LocalizationProvider>
    );
};

export default DatePickerInput;
